<template>
    <div class="pubTopManage">
        <top-component></top-component>
        <div class="content_wrap">
            <div style="display:flex ;">
                <h2 class="pro_title">订购总码洋：<span class="pro_titlenum"  >{{zongmayanglist.money || ''}}</span> 元</h2>
                <h2 class="pro_title">荐购次数：<span class="pro_titlenum">{{zongmayanglist.rmdcount || ''}}</span> 次</h2>
                <h2 class="pro_title">更新时间：<span class="pro_titlenum">{{time}}</span> </h2>
            </div>
            <div class="search-wrap box-wrap" style="padding:0; width:100%;">
                <el-tabs type="card" @tab-click="parentHandleClick" v-model="name01">
                    <el-tab-pane label="普通图书" name="普通书"></el-tab-pane>
                    <el-tab-pane label="大码洋" name="大码洋"></el-tab-pane>
                    <el-tab-pane label="总榜" name="总榜"></el-tab-pane>
                </el-tabs>
            </div>
            <div
                style="padding: 30px;border-right: 1px solid #E4E7ED;border-left: 1px solid #E4E7ED;border-bottom: 1px solid #E4E7ED;">
                <div class="search-wrap">
                    <el-tabs @tab-click="tabHandleClick" v-if="name01 == '总榜'" v-model="name02">
                        <el-tab-pane label="供应商" name="所有供应商"></el-tab-pane>
                        <el-tab-pane label="出版社" name="所有出版社"></el-tab-pane>
                        <el-tab-pane label="图书公司" name="所有图书公司"></el-tab-pane>
                    </el-tabs>
                    <el-tabs @tab-click="tabHandleClick" v-else  v-model="name02">
                        <el-tab-pane label="出版社销量排行榜" name="出版社"></el-tab-pane>
                        <el-tab-pane label="图书公司分类销售排行榜" name="出版社分类"></el-tab-pane>
                        <el-tab-pane label="图书公司销量排行榜" name="出版公司"></el-tab-pane>
                        <el-tab-pane label="图书单品销售排行榜" name="单本书"></el-tab-pane>
                    </el-tabs>
                    
                </div>
                <div style="margin: 15px auto;">
                    <p style="font-size:14px;color:#606266">排序方式：
                        <el-radio-group v-model="name03" @change="changeOrder()">
                            <el-radio label="册数">总册数</el-radio>
                            <el-radio label="定价">总码洋</el-radio>
                        </el-radio-group>
                    </p>
                </div>

                <div class="list">
                    <el-table class="MouseCursor" ref="multipleTable" v-bind:data="tableData" style="width:100%" border>
                        <el-table-column label="排行" type="index" width="80" align="center">
                        </el-table-column>
                        <el-table-column label="名称" width="300" align="center">
                            <template slot-scope="scope">
                                <span>{{ scope.row.title }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="总册数" align="center">
                            <template slot-scope="scope">
                                <span>{{ scope.row.num }}</span>&emsp;
                            </template>
                        </el-table-column>
                        <el-table-column label="总码洋" align="center">
                            <template slot-scope="scope">
                                <span>￥{{ scope.row.price }}</span>&emsp;
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
        </div>

        <bottom-component></bottom-component>
    </div>
</template>

<script>
    import TopComponent from "../Components/TopComponent.vue";
    import BottomComponent from "../Components/BottomComponent.vue";
    import Axios from "@/api/diyaxios";
    import { topt,zongmayang } from '@/api/pages'



    export default {
        data() {
            return {
                zongmayanglist:null,
                tableData: [],
                // formattedAmount: null,
                // numberoftimes:'514651',
                time: '',
                // scort:'price',
                name01: '普通书',
                name02: '出版社',
                name03: '册数'
            }
        },
        components: { TopComponent, BottomComponent },
        created() {
            // let vm = this;
            // let amount = 292459214.48;
            // this.formattedAmount = amount.toLocaleString('zh-CN', {
            //     style: 'currency',
            //     currency: 'CNY'
            // });
        },
        mounted() {
            this.getList();
            this.getTime();
            this.getzongmayang()
        },
        methods: {
            async getzongmayang(){
                let data = {}
                let res = await zongmayang(data)
                if(res.code == '200'){
                    this.zongmayanglist = res.data
                    this.zongmayanglist.money = this.zongmayanglist.money.toLocaleString('zh-CN', {
                     style: 'currency',
                      currency: 'CNY'
                     });
                }
            },
            parentHandleClick(tab, event) {
                let vm = this;
                if(vm.name01 == '总榜'){
                    vm.name02 = '所有供应商'
                }else{
                    vm.name02 = '出版社'
                }
                vm.getList();
            },
            tabHandleClick(tab, event) {
                let vm = this;
                // this.name = tab.label;
                vm.getList();
            },
            async getList() {
                let vm = this;
                let name = vm.name01 + '-' + vm.name02 + '-' + vm.name03;
                let data = { name: name }
                let res = await topt(data)
                if (res.code == '200') {
                    vm.tableData = res.data || [];
                } else {
                    vm.$message({
                        message: res.msg,
                        type: 'error'
                    });
                }
            },
            getTime() {
                let vm = this;
                Axios.post('/link/action/updateTime', {}).then(res => {
                    if (res.code == '200') {
                        this.time = res.data;
                    }
                }).catch(res => {
                    console.log(res.msg || '查询数据出错，请稍后重试');
                });
            },


            changeOrder() {
                this.getList();
            }
        }
    }
</script>

<style lang="scss" scoped>
    .pubTopManage {
        background-color: #f9f9f9;
    }

    .content_wrap {
        position: relative;
        margin: 20px auto;
        width: 1100px;
        background-color: #fff;
        padding: 30px 30px 84px;


    }

    .pro_title {
        color: #333;
        font-size: 16px;
        margin: 0 15px 15px 15px;
    }
    .pro_titlenum{
        font-size: 20px;
         color: #f13536;
    }
    .box-wrap .el-tabs__header {
        margin: 0;
    }

</style>


// WEBPACK FOOTER //
// src/views/ChildPages/PubTop.vue